<template>
  <v-dialog v-model="dialog" persistent :max-width="width + 'px'">
    <v-card class="bpm-form-data">
      <v-card-title>

          <span class="headline">{{ getCaption }}</span>
          <v-spacer></v-spacer>
          <v-btn flat fab small @click="cancel()">
              <v-icon small>close</v-icon>
          </v-btn>

          <v-container v-if="false" pb-0 grid-list-md text-no-wrap>
              <v-layout row wrap>
                  <v-flex xs12 text-xs-right>
                      <span style="border-bottom: 1px dotted #666;" @click="">Связанные задачи</span>
                  </v-flex>
              </v-layout>
          </v-container>

      </v-card-title>
      <v-card-text class="pa-0">

        <v-stepper v-model="step" class="elevation-0">
          <v-stepper-header v-if="stepper" class="elevation-0">

            <template v-for="( item, index ) in steps">
              <v-stepper-step
                :key="`${index}-step`"
                :complete="step > index"
                :step="index + 1"
              >
                {{ item.name }}
              </v-stepper-step>
              <v-divider
                v-if="index < steps.length - 1"
                :key="index + 1"
              ></v-divider>
            </template>

          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content
              v-for="( item, index ) in steps"
              :key="`${index}-content`"
              :step="index + 1"
              class="pt-2"
              style="padding: 24px 24px 24px 24px;"
            >

              <v-card class="elevation-0">
                <v-card-text :style="{ height: height + 'px' }" class="bpm-panel-content">

                  <!-- Step 1 -->
                  <div v-if="isPortStep( item.index )" style="padding-top: 100px;">
                    <template v-if="loading">
                      <loading flat :message="getMessage( 'loading' )" />
                    </template>
                    <div v-else v-for="( port ) in ports" :key="port.id" class="port-btn" @click="setFormStep( port.id )">{{ port.name }}</div>
                  </div>

                  <!-- Step 2 -->
                  <div v-else-if="isFormStep( item.index )" style="height: 100%;">
                    <template v-if="loading">
                      <loading flat :message="getMessage( 'loading' )" />
                    </template>
                    <template v-else>
                      <div v-if="form && Array.isArray( form ) && form.length >= 0" class="pb-5" style="height: 100%;">

                        <v-form ref="form" v-model="valid" lazy-validation style="height: 100%; overflow-y: auto;">
                          <div v-for="( formItem, itemIndex ) in form" :key="formItem.id">

                            <component
                              v-if="getFormComponent( formItem.type )"
                              :is="getFormComponent( formItem.type )"
                              :data="formItem"
                              v-model="form[ itemIndex ].value"
                              :mode="( formItem.type === 6 || formItem.type === 7 ) ? 'custom' : 'api'"
                              @file="getFile( itemIndex, $event )"
                            />

                            <template v-else>
                              <v-alert :value="true" color="error" outline>
                                {{ getMessage( 'unknownDataType' ) }} ({{ formItem.type }}).
                              </v-alert>
                            </template>
                          </div>

                          <!-- Название и описание процесса -->
                          <v-text-field
                                  v-if="isStartMode() && isSystemPublication()"
                                  label="Название"
                                  hint=""
                                  persistent-hint
                                  v-model="system.name"
                                  required="true"
                          />
                          <v-textarea
                                  v-if="isStartMode() && isSystemPublication()"
                                  label="Описание"
                                  hint=""
                                  persistent-hint
                                  v-model="system.description"
                                  required="false"
                          />

                          <!-- Блок управления для задач системного типа -->
                          <div v-if="isStartMode() && isSystemPublication()" style="border: 1px dashed #ccc;" class="mt-3 pa-3">

                            <!--<div class="mt-4 mb-4"></div>-->

                            <!-- Настройка сроков начала и завершения процесса -->
                            <time-interval-picker
                                    v-if="isStartMode() && isSystemPublication() && dateTime"
                                    mode="datetime"
                                    :is-time-zone="true"
                                    :fromDate="getStartDate()"
                                    :toDate="getFinishDate()"
                                    _fromLabel="Начало задачи"
                                    _toLabel="Завершение задачи"
                                    @fromDate="onFromDate"
                                    @toDate="onToDate"
                            ></time-interval-picker>

                            <div class="mt-4 mb-4" style="border-bottom: 1px dashed #ccc;"></div>

                            <!-- Выбор исполнителя -->
                            <contractor-rate
                                    v-for="( executor, index ) in executors"
                                    :key="index"
                                    :contractor="executor"
                                    :close="executors.length > 1"
                                    @delete="onDeleteExecutor"
                                    @primary="onPrimaryExecutor"
                            ></contractor-rate>

                            <v-btn color="secondary mt-3 ml-0" @click="onAddExecutor()">Выбрать исполнителей...</v-btn>

                          </div>

                        </v-form>

                      </div>
                      <div v-else class="process-result">{{ getMessage( 'emptyForm' ) }}</div>
                    </template>
                  </div>

                  <!-- Step 3 -->
                  <div v-else-if="isOptionsStep( item.index )">
                    <!--Опциональные условия запуска-->

                    <!-- Настройка сроков начала и завершения задачи -->
                    <time-interval-picker
                      v-if="false && !isExtended()"
                      mode="datetime"
                      :fromDate="getStartDate()"
                      :toDate="getFinishDate()"
                      fromLabel="Начало задачи"
                      toLabel="Завершение задачи"
                      @fromDate="onFromDate"
                      @toDate="onToDate"
                    ></time-interval-picker>

                    <!-- Выбор исполнителя -->
                    <div v-if="false && options.contractorsIds">
                      <d-being-selector
                        :defaultId="contractor"
                        :ids="options.contractorsIds"
                        :postsIds="options.postsIds"
                        :containersIds="options.containersIds"
                        label="Исполнитель"
                        hint="Выберите исполнителя из списка"
                        v-model="contractor"
                        :use-faker="false"
                      />
                    </div>

                    <!-- Отложенный запуск -->
                    <div v-if="options.deferred" class="mb-4">
                      <!-- <p class="title">Отложенный запуск</p> -->
                      <!-- <p>Можно Указать дату и время запуска бизнес-процесса.</p> -->
                      <div class="" style="min-height: 48px;">
                        <v-switch label="Отложить запуск" v-model="letDeferrer"></v-switch>
                      </div>
                      <v-slide-y-transition>
                        <v-card v-if="letDeferrer">
                          <v-card-text class="grey lighten-4">
                            <div class="title my-3">Установите дату и время отложенного запуска</div>
                            <v-container grid-list-md>
                              <v-layout v-bind="binding">
                                <v-flex sm12 md6>
                                  <v-date-picker
                                          :first-day-of-week="1"
                                          locale="ru-ru"
                                          v-model="deferrerDate"
                                  ></v-date-picker>
                                </v-flex>
                                <v-flex sm12 md6 lg6>
                                  <v-time-picker v-model="deferrerTime" format="24hr"></v-time-picker>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-card-text>
                        </v-card>
                      </v-slide-y-transition>
                    </div>

                    <!-- Срок исполнения -->
                    <div v-if="options.time_limit" class="mb-4">
                      <p class="title">Ограничение на время выполнения бизнес-процесса</p>
                      <p>Установлено ограничение на время выполнения бизнес-процесса: <strong>{{ getTimeValue( options.time_limit ) }} {{ getTimeTitle( options.time_limit ) }}</strong>.</p>

                      <template v-if="options.time_limit_changeable">
                        <v-expansion-panel>
                          <v-expansion-panel-content>
                            <div slot="header">Изменить</div>
                            <v-card>
                              <v-card-text class="grey lighten-4">
                                <!-- <v-container grid-list-sm>
                                  <v-layout row wrap>
                                      <v-flex md12> -->
                                <v-text-field
                                        label="Лимит времени"
                                        type="number"
                                        v-model="options.time_limit">
                                </v-text-field>
                                <!-- </v-flex>
                                <v-flex md12> -->
                                <!-- <select class="" name="" v-model="timeLimitFloor">
                                  <option v-for="tlt in timeLimitTypes" :value="tlt.floor">{{ getNoun( timeLimit, tlt.title ) }}</option>
                                </select> -->
                                <v-radio-group v-model="timeLimitFloor" row>
                                  <v-radio v-for="tlt in timeLimitTypes" :key="tlt.floor"
                                           :label="getNoun( options.time_limit, tlt.title )"
                                           :value="tlt.floor">
                                  </v-radio>
                                </v-radio-group>
                                <!-- </v-flex>
                            </v-layout>
                          </v-container> -->
                              </v-card-text>
                            </v-card>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </template>
                      <template v-else>
                        <p>Изменить ограничение времени исполнения нельзя.</p>
                      </template>
                    </div>

                  </div>

                  <!-- Step: Result -->
                  <div v-else-if="isResultStep( item.index )" class="process-result">
                    <template v-if="error">
                      <div v-if="isStartMode()" class="process-error">
                        {{ getMessage( 'startError' ) }}
                      </div>
                      <div v-else class="process-error">
                        {{ getMessage( 'finishError' ) }}
                      </div>
                    </template>
                    <div v-else >
                      <div v-if="isStartMode()">{{ getMessage( 'startSuccess' ) }}</div>
                      <div v-else-if="isFinishMode()">{{ getMessage( 'finishSuccess' ) }}</div>
                      <div v-else>{{ getMessage( 'editSuccess' ) }}</div>
                    </div>
                  </div>

                  <!-- Step: Process Information -->
                  <div v-else-if="isProcessInfoStep( item.index )" class="process-data">
                    <template v-if="loading">
                      <loading flat :message="getMessage( 'loading' )" />
                    </template>
                    <template v-if="error">
                      <div class="process-error">
                        {{ getMessage( 'inputDataError' ) }}
                      </div>
                    </template>
                    <div v-if="!loading && !error" style="max-height: 400px; overflow-y: auto;">

                      <div class="mb-4">
                        Общая информация
                      </div>
                      <v-list two-line dense class="mb-5">
                        <v-list-tile
                                v-for="(item, index) in processInfo"
                                :key="index"
                                avatar
                                @click=""
                        >
                          <v-list-tile-avatar>
                            <img v-if="item.photo" :src="item.photo"/>
                            <v-icon v-else style="color: #907fa5;">{{ item.icon }}</v-icon>
                          </v-list-tile-avatar>

                          <v-list-tile-content>
                            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                            <v-list-tile-sub-title>{{ item.subtitle }}</v-list-tile-sub-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>



                      <div v-if="inputData.length" class="mb-4">
                        Входящие данные
                      </div>
                      <v-data-table
                              v-if="inputData.length"
                              :items="inputData"
                              class="mb-5"
                              hide-actions
                              hide-headers
                              no-data-text=""
                      >
                        <template v-slot:items="props">
                          <td class="text-xs-left">{{ props.item.name }}</td>
                          <td class="text-xs-right">{{ props.item.value }}</td>
                        </template>
                      </v-data-table>
                      <!--<div v-else class="process-no-data" style="border-top: 1px dotted #ccc; border-bottom: 1px dotted #ccc;">-->
                        <!--Входящих данных по выбранной задаче нет-->
                      <!--</div>-->

                      <div v-if="outputData.length" class="mb-4">
                        Исходящие данные
                      </div>
                      <v-data-table
                              v-if="outputData.length"
                              :items="outputData"
                              hide-actions
                              hide-headers
                              no-data-text=""
                      >
                        <template v-slot:items="props">
                          <td class="text-xs-left">{{ props.item.name }}</td>
                          <td class="text-xs-right">{{ props.item.value }}</td>
                        </template>
                      </v-data-table>
                      <!--<div v-else class="process-no-data">-->
                        <!--Исходящих данных по выбранной задаче нет-->
                      <!--</div>-->

                    </div>
                  </div>

                  <!-- Step: Input data -->
                  <div v-else-if="isInputDataStep( item.index )" class="process-data">
                    <template v-if="loading">
                      <loading flat :message="getMessage( 'loading' )" />
                    </template>
                    <template v-if="error">
                      <div class="process-error">
                        {{ getMessage( 'inputDataError' ) }}
                      </div>
                    </template>
                    <div v-if="!loading && !error">
                      <div v-if="inputData.length" class="process-data">
                        Входящие данные
                      </div>
                      <div v-else class="process-no-data">
                        Входящих данных по выбранной задаче нет
                      </div>
                      <v-data-table
                              :items="inputData"
                              style="overflow: auto; max-height: 340px;"
                              class=""
                              hide-actions
                              hide-headers
                              no-data-text=""
                      >
                        <template v-slot:items="props">
                          <td class="text-xs-left">{{ props.item.name }}</td>
                          <td class="text-xs-right">{{ props.item.value }}</td>
                        </template>
                      </v-data-table>
                    </div>
                  </div>

                  <!-- Step: Output data -->
                  <div v-else-if="isOutputDataStep( item.index )" class="process-data">
                    <template v-if="loading">
                      <loading flat :message="getMessage( 'loading' )" />
                    </template>
                    <template v-if="error">
                      <div class="process-error">
                        {{ getMessage( 'outputDataError' ) }}
                      </div>
                    </template>
                    <div v-if="!loading && !error">
                      <div v-if="outputData.length" class="process-data">
                        Исходящие данные
                      </div>
                      <div v-else class="process-no-data">
                        Исходящих данных по выбранной задаче нет
                      </div>
                      <v-data-table
                              :items="outputData"
                              style="overflow: auto; max-height: 340px;"
                              hide-actions
                              hide-headers
                              no-data-text=""
                      >
                        <template v-slot:items="props">
                          <td class="text-xs-left">{{ props.item.name }}</td>
                          <td class="text-xs-right">{{ props.item.value }}</td>
                        </template>
                      </v-data-table>
                    </div>
                  </div>

                  <!-- Step: Edit -->
                  <div v-else-if="isEditStep( item.index )" class="" style="max-height: 400px; overflow-y: auto;">
                      <!-- Название и описание процесса -->
                      <v-text-field
                              v-if="true"
                              label="Название"
                              hint=""
                              persistent-hint
                              v-model="system.name"
                              required="true"
                      />
                      <v-textarea
                              v-if="true"
                              label="Описание"
                              hint=""
                              persistent-hint
                              v-model="system.description"
                              required="false"
                      />

                      <!-- Блок управления для задач системного типа -->
                      <div v-if="process && Array.isArray( process.contractors ) && process.contractors.length" style="border: 1px dashed #ccc;" class="mt-3 pa-3">

                        <!-- Настройка сроков начала и завершения процесса >>> system.startDate && system.finishDate -->
                        <time-interval-picker
                                v-if="dateTime"
                                mode="datetime"
                                :is-time-zone="false"
                                :fromDate="system.startDate"
                                :toDate="system.finishDate"
                                @fromDate="onFromDate"
                                @toDate="onToDate"
                        ></time-interval-picker>
                        <!-- Выбор исполнителя -->
                        <div class="mt-4 mb-4" style="border-bottom: 1px dashed #ccc;"></div>
                        <contractor-rate
                                v-for="( executor, index ) in executors"
                                :key="index"
                                :contractor="executor"
                                :close="executors.length > 1"
                                @delete="onDeleteExecutor"
                                @primary="onPrimaryExecutor"
                        ></contractor-rate>
                        <v-btn color="secondary mt-3 ml-0" @click="onAddExecutor()">Выбрать исполнителей...</v-btn>

                      </div>

                  </div>

                </v-card-text>

                <v-card-actions style="padding: 0;">

                  <div v-if="isCloseButton( item.index )" class="close" @click="cancel()">
                    {{ getMessage( 'btnClose' ) }}
                  </div>

                  <v-spacer></v-spacer>

                  <div v-if="isPrevButton( item.index )" class="close" @click="prevStep( step )">
                    {{ getMessage( 'btnPrev' ) }}
                  </div>
                  <div v-if="isNextButton( item.index )" class="confirm" @click="nextStep( step )">
                    {{ getMessage( 'btnNext' ) }}
                  </div>
                  <div v-if="isStartButton( item.index )" class="confirm" @click="confirmStart()">
                    {{ getMessage( 'btnStart' ) }}
                  </div>
                  <div v-if="isFinishButton( item.index )" class="confirm" @click="confirmFinish()">
                    {{ getMessage( 'btnFinish' ) }}
                  </div>
                  <div v-if="isSaveButton( item.index )" class="confirm" @click="editProcess()">
                    {{ getMessage( 'btnSave' ) }}
                  </div>

                </v-card-actions>
              </v-card>

            </v-stepper-content>
          </v-stepper-items>

        </v-stepper>

        <contractor-picker
                :selected="getExecutorsPostsIds()"
                ref="executorPicker"
                @ok="onRefreshExecutors"
        ></contractor-picker>

      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style>

  .d-file-uploader__input {
    opacity: 0;
    visibility: hidden;
    position: absolute;
    width: 0.1px;
    height: 0.1px;
    overflow: hidden;
    z-index: -1;
  }

  .bpm-form-data {
    font-family: Oxygen, sans-serif;
  }

  .bpm-form-data .bpm-panel-content {
    max-height: 500px;
    min-height: 300px;
    padding: 0;
  }

  .bpm-form-data .port-btn {
    background-color: #907fa5;
    border-radius: 4px;
    color: #eee;
    cursor: pointer;
    font-size: 18px;
    min-height: 60px;
    padding: 16px 10px;
    text-transform: none;
    width: 100%;
    margin-bottom: 20px;
    text-align: center;
  }

  .bpm-form-data .port-btn:hover {
    background-color: #9f8eb4;
  }

  .bpm-form-data .close {
    background-color: #ccccd7;
    border-radius: 4px;
    color: #777787;
    cursor: pointer;
    font-size: 15px;
    padding: 10px 20px;
    text-transform: none;
    margin-right: 8px;
  }

  .bpm-form-data .close:hover {
    background-color: #c2c2cd;
  }

  .bpm-form-data .confirm {
    background-color: #907fa5;
    border-radius: 4px;
    color: #eee;
    cursor: pointer;
    font-size: 15px;
    padding: 10px 20px;
    text-transform: none;
  }

  .bpm-form-data .confirm:hover {
    background-color: #9f8eb4;
  }

  .bpm-form-data .process-result {
    font-size: 20px;
    text-align: center;
    padding-top: 150px;
  }

  .bpm-form-data .process-data {
    font-size: 16px;
    font-weight: 200;
    margin-bottom: 16px;
    text-align: center;
  }

  .bpm-form-data .process-data .process-error {
    color: #772517;
    font-size: 16px;
    text-align: center;
    padding-top: 150px;
  }

  .bpm-form-data .process-no-data {
    /*background: #ddd;*/
    font-size: 16px;
    text-align: center;
    /*padding-top: 150px;*/
    padding-top: 50px;
    padding-bottom: 50px;
    color: #777;
    font-style: italic;
  }

  .bpm-form-data .process-data-delimiter {
    border-bottom: 1px dotted #ccc;
    /*margin-bottom: 40px;*/
    /*padding-bottom: 40px;*/
  }

  .bpm-form-data .process-data-error {
    font-size: 20px;
    text-align: center;
    padding-top: 150px;
  }

  .bpm-form-data .process-result .process-error {
    color: #772517;
    font-size: 16px;
    text-align: center;
    /*padding-top: 150px;*/
  }

</style>

<script>

  import time_limit from '../../mixins/time_limit'
  import apiRun from '@/apps/bpm/api/run/api.js'
  import apiDisk from '@/apps/disk/api'
  import apiOrg from '@/apps/org/api/orgstructure'
  import { mapGetters } from 'vuex'
  import { getValidationData } from '@/helpers/errors'
  import httpClient from '@/api/http-client'
  import moment from 'moment'
  import uuidv4 from 'uuid/v4'

  import DBeingSelector from '@/components/BeingSelector'
  import TreeSelector from '@/components/TreeSelector'

  import FormFile from '../../components/form/FormFile'
  import FormSelect from '../../components/form/FormSelect'
  import FormInput from '../../components/form/FormInput'
  import FormRadioButton from '../../components/form/FormRadioButton'
  import FormTextarea from '../../components/form/FormTextarea'
  import FormCheckbox from '../../components/form/FormCheckbox'
  import FormDate from '../../components/form/FormDate'
  import FormEmail from '../../components/form/FormEmail'
  import TimeIntervalPicker from '../TimeIntervalPicker'
  import ContractorPicker from '../ContractorPicker'
  import ContractorRate from '../ContractorRate'

  /**
   *
   *
   */
  const cancelToken = httpClient.cancelToken

  /**
   * Коды шагов диалогового окна.
   *
   * @type {number}
   */
  const STEP_PORTS = 10
  const STEP_FORM = 20
  const STEP_OPTIONS = 30
  const STEP_RESULT = 40
  const STEP_INPUT_DATA = 50
  const STEP_OUTPUT_DATA = 60
  const STEP_PROCESS_INFO = 70
  const STEP_EDIT = 80

  /**
   * Формат даты и времени.
   *
   */
  const DATETIME_FORMAT = 'D MMMM YYYY, HH:mm, dddd'

  /**
   *
   *
   */
  const MODES = {

    start: {
      steps: [
        { index: STEP_PORTS, name: 'Варианты', buttons: [] },
        { index: STEP_FORM, name: 'Данные', buttons: [] },
        { index: STEP_OPTIONS, name: 'Опции', buttons: [] },
        { index: STEP_RESULT, name: 'Результат', buttons: [] }
      ]
    },

    data: {
      steps: [
        { index: STEP_PROCESS_INFO, name: 'Общая информация', buttons: [] },
        { index: STEP_INPUT_DATA, name: 'Входящие данные', buttons: [] },
        { index: STEP_OUTPUT_DATA, name: 'Исходящие данные', buttons: [] }
      ]
    },

    finish: {
      steps: [
        { index: STEP_PORTS, name: 'Варианты', buttons: [] },
        { index: STEP_FORM, name: 'Данные', buttons: [] },
        { index: STEP_OPTIONS, name: 'Опции', buttons: [] },
        { index: STEP_RESULT, name: 'Результат', buttons: [] }
      ]
    }
  }

  /**
   * Доступные шаги.
   *
   */
  const DEFAULT_STEPS = [
    { index: STEP_PORTS, name: 'Варианты', buttons: [] },
    { index: STEP_FORM, name: 'Данные', buttons: [] },
    { index: STEP_OPTIONS, name: 'Опции', buttons: [] },
    { index: STEP_RESULT, name: 'Результат', buttons: [] },
    { index: STEP_PROCESS_INFO, name: 'Общая информация', buttons: [] },
    { index: STEP_INPUT_DATA, name: 'Входящие данные', buttons: [] },
    { index: STEP_OUTPUT_DATA, name: 'Исходящие данные', buttons: [] },
    { index: STEP_EDIT, name: 'Редактирование данных', buttons: [] }
  ]

  /**
   * Названия, сообщения и тексты по умолчанию.
   *
   */
  const DEFAULT_MESSAGES = {
    loading: 'Загрузка данных...',
    startCaption: 'Запуск процесса',
    finishCaption: 'Завершение процесса',
    dataCaption: 'Данные задачи',
    editCaption: 'Редактирование задачи',
    btnClose: 'Закрыть',
    btnPrev: 'Назад',
    btnNext: 'Далее',
    btnStart: 'Запустить',
    btnFinish: 'Завершить',
    btnSave: 'Сохранить',
    startSuccess: 'Процесс успешно запущен',
    finishSuccess: 'Процесс успешно завершен',
    editSuccess: 'Данные задачи успешно изменены',
    startError: 'Ошибка. Процесс не запущен',
    finishError: 'Ошибка. Процесс не завершен',
    inputDataError: 'Ошибка. Входящие данные не получены',
    outputDataError: 'Ошибка. Исходящие данные не получены',
    fileUploadError: 'Ошибка загрузки файла',
    emptyPorts: '',
    emptyForm: 'Ввод данных не требуется',
    unknownDataType: 'Указан неподдерживаемый тип данных'
  }

  /**
   * Названия доступных статусов процесса.
   *
   */
  const PROCESS_STATUSES = {
    pool: 'В пуле',
    pending: 'В ожидании',
    running: 'В работе',
    hold: 'Приостановлена',
    canceled: 'Отменена',
    finished: 'Завершена'
  }

  /**
   * Шаблоны отображения информации по процессу.
   *
   */
  const PROCESS_INFO_TEMPLATES = [
    { type: 'customer', icon: 'mdi-account-circle', iconClass: 'amber white--text', title: '-', subtitle: 'Имя и должность заказчика' },
    { type: 'executor', icon: 'mdi-account-circle', iconClass: 'amber white--text', title: '-', subtitle: 'Имя и должность исполнителя' },
    { type: 'manager', icon: 'mdi-account-circle', iconClass: 'amber white--text', title: '-', subtitle: 'Имя и должность руководителя' },
    { type: 'tag', icon: 'mdi-tag', iconClass: 'amber white--text', title: '-', subtitle: 'Номер' },
    { type: 'created', icon: 'date_range', iconClass: 'blue white--text', title: '-', subtitle: 'Дата создания' },
    { type: 'deadline', icon: 'timelapse', iconClass: 'amber white--text', title: '-', subtitle: 'Срок исполнения' },
    { type: 'finished', icon: 'done', iconClass: 'blue white--text', title: '-', subtitle: 'Дата завершения' },
    { type: 'canceled', icon: 'cancel', iconClass: 'blue white--text', title: '-', subtitle: 'Дата отмены' },
    { type: 'status', icon: 'mdi-bookmark-outline', iconClass: 'amber white--text', title: '-', subtitle: 'Статус' }
  ]

  /**
   *
   *
   */
  const DEFAULT_INPUT_DATA = [
    {
      name: 'Фамилия',
      value: 'Полуэктов'
    },
    {
      name: 'Имя',
      value: 'Константин'
    },
    {
      name: 'Отчество',
      value: 'Владимирович'
    },
    {
      name: 'Телефон',
      value: '+7 913 382 2279'
    },
    {
      name: 'Электронная почта',
      value: 'poluektovkv@gmail.com'
    }
  ]

  /**
   *
   *
   */
  const DEFAULT_OUTPUT_DATA = [
    {
      name: 'Ананасы',
      value: '4 кг'
    },
    {
      name: 'Апельсины',
      value: '5 кг'
    },
    {
      name: 'Арбузы',
      value: '12 кг'
    },
    {
      name: 'Бананы',
      value: '3.5 кг'
    },
    {
      name: 'Виноград',
      value: '4 кг'
    },
    {
      name: 'Дыни',
      value: '8 кг'
    },
    {
      name: 'Клубника',
      value: '1.5 кг'
    },
    {
      name: 'Персики',
      value: '2.5 кг'
    },
    {
      name: 'Черешня',
      value: '8 кг'
    },
    {
      name: 'Яблоки',
      value: '7.5 кг'
    }
  ]

  /**
   *
   *
   */
  const DEFAULT_RATE_VALUE = '30'

  /**
   *
   *
   */
  const DEFAULT_RATE_UNIT = 10



  /**
   *
   *
   */
  export default {

    name: 'ProcessControlPanel',

    mixins: [ time_limit ],

    components: {
      DBeingSelector,
      FormFile,
      FormSelect,
      FormInput,
      FormRadioButton,
      FormTextarea,
      FormCheckbox,
      FormDate,
      FormEmail,
      TimeIntervalPicker,
      ContractorPicker,
      ContractorRate,
      TreeSelector
    },

    props: {

      // Режим диалогового окна.
      mode: {
        type: String,
        required: true,
        validator: function ( value ) {
          return [ 'start', 'data', 'edit', 'finish' ].indexOf( value ) !== -1
        }
      },

      // Публикация.
      publication: {
        type: Object,
        required: false,
        default: null
      },

      // Процесс.
      process: {
        type: Object,
        required: false,
        default: null
      },

      // Заголовок диалогового окна.
      caption: {
        type: String,
        required: false,
        default: null
      },

      // Расширенный интерфейс.
      extended: {
        type: Boolean,
        required: false,
        default: true
      },

      // Включение индикатора шагов.
      stepper: {
        type: Boolean,
        required: false,
        default: true
      },

      // Включение быстрого завершения.
      quickFinish: {
        type: Boolean,
        required: false,
        default: false
      },

      // Отображение кнопки Закрыть.
      close: {
        type: Boolean,
        required: false,
        default: true
      },

      // Автоматическое закрытие диалогового окна.
      autoClose: {
        type: Boolean,
        required: false,
        default: false
      },

      // Названия, сообщения и тексты.
      messages: {
        type: Object,
        required: false,
        default: () => {}
      },

      // Включение режима интервалов времени.
      dateTime: {
        type: Boolean,
        required: false,
        default: false
      },

      // Дата планового запуска процесса.
      startDate: {
        type: String | Object,
        required: false,
        default: null
      },

      // Дата планового завершения процесса.
      finishDate: {
        type: String | Object,
        required: false,
        default: null
      },

      // Высота диалогового окна.
      height: {
        type: Number | String,
        required: false,
        default: 460
      },

      // Ширина диалогового окна.
      width: {
        type: Number | String,
        required: false,
        default: 420
      },

      //
      data: {
        type: Object,
        required: false,
        default: null
      },
    },

    /**
     * Операционные данные компонента.
     *
     */
    data() {

      return {

        // Набор доступных шагов для диалогового окна.
        defaultSteps: DEFAULT_STEPS,

        // Набор доступных шагов для диалогового окна.
        // defaultSteps: MODES.start.steps,

        // Текущий набор шагов диалогового окна.
        steps: [
          { index: STEP_PORTS }
        ],

        // Номер текущего шага.
        step: 1,

        // Состояние диалогового окна.
        dialog: false,

        // Системные данные процесса.
        system: {
          name: null,
          description: null,
          startDate: null,
          finishDate: null
        },

        // Список портов.
        ports: [],

        // Форма данных.
        form: [],

        // Опции запуска процесса.
        options: {},

        // Общая информация по процесссу.
        processInfo: PROCESS_INFO_TEMPLATES,

        // Входящие и исходящие данные процесса.
        inputData: [], // DEFAULT_INPUT_DATA,
        outputData: [], // DEFAULT_OUTPUT_DATA,

        // Идентификатор выбранного порта.
        portId: null,

        // Флаг процесса загрузки данных.
        loading: false,

        // Флаг наличия ошибок.
        error: false,

        // Названия, сообщения и тексты по умолчанию.
        defaultMessages: DEFAULT_MESSAGES,

        // Список файлов для загрузки на сервер (сервис Диск).
        filesToDisk: [],

        // Список промисов для отправленных на сервер файлов.
        promisesToDisk: [],

        // Доступные типы данных для формы данных.
        formComponents: {
          1: 'FormInput',
          2: 'FormTextarea',
          3: 'FormEmail',
          4: 'FormDate',
          5: 'FormCheckbox',
          6: 'FormRadioButton',
          7: 'FormSelect',
          8: 'FormSelect',
          9: 'FormFile',
          10: 'FormRadioButton',
        },

        //
        executors: [],



        // ------- Удалить после рефакторинга

        formMenus: [],
        menu2: false,
        date: null,
        valid: true,

        // Time limits data
        timeLimitSec: 0,
        timeLimit: '',
        timeLimitFloor: 60,
        isTimeLimitChangeable: false,

        isDeferred: false,
        letDeferrer: false,
        deferrerDate: null,
        deferrerTime: null,

        contractors: null,
        postIds: null,
        containerIds: null,
        contractor: null,

        emptyParams: false,

        // -------
      }
    },

    /**
     * Инициализация входных системных данных.
     *
     */
    watch: {

      /**
       * Публикация (режим запуска процесса).
       *
       */
      publication: {

        handler( publication ) {

        },

        // Необходимо для инициализации значения по умолчанию
        immediate: true,

        deep: true
      },

      /**
       * Процесс (режим редактирования или завершения процесса).
       *
       */
      process: {

        handler( process ) {

          if ( process ) {

            this.system.startDate = process.start_at
            this.system.finishDate = process.finish_at

            if ( Array.isArray( process.contractors ) && process.contractors.length !== 0 ) {
              this.executors = process.contractors
            }

            // this.getPostsData( [ process.customer_id ] ).then( posts => {
            //
            //   let post = posts.length
            //     ? posts[ 0 ]
            //     : null
            //
            //   // Вывод информации о процессе (задаче).
            //   this.processInfo = this.getProcessInfo( process, post )
            // } )

            //
            this.getPostsData( [ process.customer_id, process.contractor_id, process.manager_id ] ).then( posts => {

              console.log( `after posts >> `, posts )

              // Вывод информации о процессе (задаче).
              this.processInfo = this.getProcessInfo( process, Array.isArray( posts ) ? posts : [] )
            } )
          }
        },

        // Необходимо для инициализации значения по умолчанию
        immediate: true,

        deep: true
      },

      /**
       * Дата и время запуска процесса.
       *
       */
      startDate: {

        handler( value ) {

          // Если режима запуска процесса,
          // установка даты и времени запуска процесса по умолчанию.
          if ( this.isStartMode() ) {
            this.system.startDate = value
          }
        },

        // Необходимо для инициализации значения по умолчанию
        immediate: true
      },

      /**
       * Дата и время завершения процесса.
       *
       */
      finishDate: {

        handler( value ) {

          // Если режима запуска процесса,
          // установка даты и времени завершения процесса по умолчанию.
          if ( this.isStartMode() ) {
            this.system.finishDate = value
          }
        },

        // Необходимо для инициализации значения по умолчанию
        immediate: true
      }
    },

    /**
     * Вычисляемые свойства.
     *
     */
    computed: {

      ...mapGetters( 'app/helpers', [ 'formatDatetime' ] ),
      ...mapGetters( 'app/account', [ 'getPost' ] ),

      /**
       *
       *
       */
      selfPost() {
        return this.getPost()
      },

      /**
       * Получение заголовка диалогового окна.
       *
       */
      getCaption() {

        if ( this.isStartMode() ) {
          return this.getMessage( 'startCaption' )
        }
        else if ( this.isFinishMode() ) {
          return this.getMessage( 'finishCaption' )
        }
        else if ( this.isDataMode() ) {
          return this.getMessage( 'dataCaption' )
        }
        else if ( this.isEditMode() ) {
          return this.getMessage( 'editCaption' )
        }

        return 'Управление процессом'
      },

      /**
       * Получение списка текстов.
       *
       */
      getMessages() {
         return Object.assign( {}, this.defaultMessages, this.messages )
      }
    },

    /**
     * После монтирования компонента.
     *
     */
    mounted() {

    },

    /**
     * После создания компонента.
     *
     */
    created() {

    },

    /**
     * Методы компонента.
     *
     */
    methods: {

      /**
       * Общая инициализация компонента диалогового окна.
       *
       */
      init() {

        this.ports = []
        this.step = 1
        this.error = false

        if ( this.isStartMode() ) {

          this.setDefaultExecutors()
          this.setStartStep()
        }
        else {
          this.stepPort()
        }

        // Получение входящих и исходящих данных
        if ( this.isDataMode() ) {
          this.getData()
        }
        else if ( this.isEditMode() ) {
          //
          this.system.name = this.process.name
          this.system.description = this.process.description
          this.system.startDate = this.process.start_at
          this.system.finishDate = this.process.finish_at
          this.loadProcessExecutors()
        }
      },

      /**
       * Текущий режим - Запуск процесса?
       *
       */
      isStartMode() {
        return this.mode === 'start'
      },

      /**
       * Текущий режим - Просмотр данных?
       *
       */
      isDataMode() {
        return this.mode === 'data'
      },

      /**
       * Текущий режим - Редактирование данных?
       *
       */
      isEditMode() {
        return this.mode === 'edit'
      },

      /**
       * Текущий режим - Завершение процесса?
       *
       */
      isFinishMode() {
        return this.mode === 'finish'
      },

      /**
       * Расширенный интерфейс?
       *
       */
      isExtended() {
        return this.extended === true
      },

      /**
       *
       *
       */
      isSystemPublication() {
        return this.publication && ( this.publication.scope === 'system' )
      },

      /**
       * Переход к предыдущему шагу.
       *
       */
      prevStep( index ) {

        if ( index > 1 ) {
          this.step = index - 1
        }
      },

      /**
       * Переход к следующему шагу.
       *
       */
      nextStep( index ) {

        if ( index < this.steps.length ) {
          this.step = index + 1
        }
      },

      /**
       * Указанный шаг является шагом выбора порта?
       *
       */
      isPortStep( index ) {
        return index === STEP_PORTS
      },

      /**
       * Указанный шаг является шагом ввода данных?
       *
       */
      isFormStep( index ) {
        return index === STEP_FORM
      },

      /**
       * Указанный шаг является шагом настройки опций?
       *
       */
      isOptionsStep( index ) {
        return index === STEP_OPTIONS
      },

      /**
       * Указанный шаг является шагом результата?
       *
       */
      isResultStep( index ) {
        return index === STEP_RESULT
      },

      /**
       * Указанный шаг является шагом общей инофрмации о процессе?
       *
       */
      isProcessInfoStep( index ) {
        return index === STEP_PROCESS_INFO
      },

      /**
       * Указанный шаг является шагом просмотра входящих данных?
       *
       */
      isInputDataStep( index ) {
        return index === STEP_INPUT_DATA
      },

      /**
       * Указанный шаг является шагом просмотра исходящих данных?
       *
       */
      isOutputDataStep( index ) {
        return index === STEP_OUTPUT_DATA
      },

      /**
       * Указанный шаг является шагом редактирования данных?
       *
       */
      isEditStep( index ) {
        return index === STEP_EDIT
      },

      /**
       * Инициализация списка шагов.
       *
       */
      initSteps() {

        this.steps = []

        if ( this.isDataMode() ) {

          // Общие данные по процессу, входящие и исходящие данные
          this.steps.push( this.getDefaultStepByIndex( STEP_PROCESS_INFO ) )
          // this.steps.push( this.getDefaultStepByIndex( STEP_INPUT_DATA ) )
          // this.steps.push( this.getDefaultStepByIndex( STEP_OUTPUT_DATA ) )
        }
        else if ( this.isEditMode() ) {

          // Редактирование данных
          this.steps.push( this.getDefaultStepByIndex( STEP_EDIT ) )

          // Результат
          this.steps.push( this.getDefaultStepByIndex( STEP_RESULT ) )
        }
        else {

          // Порты
          if ( this.isFinishMode() && ( !this.quickFinish || this.ports.length > 1 ) ) {
            this.steps.push( this.getDefaultStepByIndex( STEP_PORTS ) )
          }

          // Данные
          this.steps.push( this.getDefaultStepByIndex( STEP_FORM ) )

          // Опции
          if ( this.isStartMode() && this.isOptionsEnabled() ) {
            this.steps.push( this.getDefaultStepByIndex( STEP_OPTIONS ) )
          }

          // Результат
          this.steps.push( this.getDefaultStepByIndex( STEP_RESULT ) )
        }

        // Настройка списка кнопок для каждого шага.
        this.initButtons()
      },

      /**
       * Получение указанного шага из набора доступных шагов.
       *
       */
      getDefaultStepByIndex( index ) {
        return this.defaultSteps.find( step => step.index === index )
      },

      /**
       * Получение указанного шага из набора текущих шагов.
       *
       */
      getStepByIndex( index ) {
        return this.steps.find( step => step.index === index )
      },

      /**
       * Есть ли в списке шаг выбора порта?
       *
       */
      isPortStepExist() {
        return typeof this.getStepByIndex( STEP_PORTS ) !== 'undefined'
      },

      /**
       * Есть ли в списке шаг ввода данных?
       *
       */
      isFormStepExist() {
        return typeof this.getStepByIndex( STEP_FORM ) !== 'undefined'
      },

      /**
       * Есть ли в списке шаг настройки опций?
       *
       */
      isOptionsStepExist() {
        return typeof this.getStepByIndex( STEP_OPTIONS ) !== 'undefined'
      },

      /**
       * Есть ли в списке шаг результата?
       *
       */
      isResultStepExist() {
        return typeof this.getStepByIndex( STEP_RESULT ) !== 'undefined'
      },

      /**
       * Доступны ли опции при запуске процесса?
       *
       */
      isOptionsEnabled() {
        return this.isExtended() && Object.keys( this.options ).length !== 0
      },

      /**
       * Настройка списка кнопок для каждого шага.
       *
       */
      initButtons() {

        this.steps = this.steps.map( ( step ) => {
          step.buttons = this.getButtons( step )
          return step
        } );
      },

      /**
       * Получение списка кнопок для указанного шага.
       *
       */
      getButtons( step ) {

        let buttons = []

        if ( this.close ) {
          buttons.push( 'close' )
        }

        if ( step.index === STEP_PORTS ) {
          // buttons = []
        }
        else if ( step.index === STEP_FORM ) {

          if ( this.isFinishMode() ) {
            buttons.push( 'finish' )
            if ( this.isPortStepExist() ) {
              buttons.push( 'prev' )
            }
          }
          else {
            if ( this.isOptionsStepExist() ) {
              buttons.push( 'next' )
            }
            else {
              buttons.push( 'start' )
            }
          }
        }
        else if ( step.index === STEP_OPTIONS ) {

          buttons.push( 'start' )
          if ( this.isFormStepExist() ) {
            buttons.push( 'prev' )
          }
        }
        else if ( step.index === STEP_RESULT ) {
          // buttons = []
        }
        else if ( step.index === STEP_PROCESS_INFO ) {
          // buttons.push( 'next' )
        }
        else if ( step.index === STEP_INPUT_DATA ) {
          buttons.push( 'prev' )
          buttons.push( 'next' )
        }
        else if ( step.index === STEP_OUTPUT_DATA ) {
          buttons.push( 'prev' )
        }
        else if ( step.index === STEP_EDIT ) {
          buttons.push( 'save' )
        }

        return buttons
      },

      /**
       * Инициализация опций.
       *
       */
      initOptions( data ) {

        this.options = {}

        this.contractor = null

        if ( Array.isArray( data.contractors )  ) {
          this.options.contractorsIds = data.contractors ? data.contractors : null
        }

        if ( Array.isArray( data.contractors_containers )  ) {
          this.options.containersIds = data.contractors_containers ? data.contractors_containers : null
        }

        if ( Array.isArray( data.contractors_posts ) ) {
          this.options.postsIds = data.contractors_posts ? data.contractors_posts : null // Object.assign( {}, data.contractors_posts )
        }

        // this.postIds = data.contractors_posts ? data.contractors_posts : null
        // this.containerIds = data.contractors_containers ? data.contractors_containers : null

        if ( data.deferred ) {
          this.options.deferred = data.deferred
        }

        if ( data.time_limit_changeable === true ) {
          this.options.time_limit_changeable = data.time_limit_changeable
          this.options.time_limit = data.time_limit
        }
      },

      /**
       * Сброс системных данных.
       *
       */
      resetSystemData() {

        this.system.name = null
        this.system.description = null
      },

      /**
       * Отображается ли указанная кнопка
       * на указанном шаге?
       *
       */
      isButton( index, button ) {

        let step = this.steps.find( step => step.index === index )

        if ( Array.isArray( step.buttons ) ) {
          return step.buttons.indexOf( button ) !== -1
        }

        return false
      },

      /**
       * Отображается ли кнопка Закрыть
       * на указанном шаге?
       *
       */
      isCloseButton( index ) {
        return this.isButton( index, 'close' )
      },

      /**
       * Отображается ли кнопка Назад
       * на указанном шаге?
       *
       */
      isPrevButton( index ) {
        return this.isButton( index, 'prev' )
      },

      /**
       * Отображается ли кнопка Далее
       * на указанном шаге?
       *
       */
      isNextButton( index ) {
        return this.isButton( index, 'next' )
      },

      /**
       * Отображается ли кнопка Запустить
       * на указанном шаге?
       *
       */
      isStartButton( index ) {
        return this.isButton( index, 'start' )
      },

      /**
       * Отображается ли кнопка Завершить
       * на указанном шаге?
       *
       */
      isFinishButton( index ) {
        return this.isButton( index, 'finish' )
      },

      /**
       * Отображается ли кнопка Сохранить
       * на указанном шаге?
       *
       */
      isSaveButton( index ) {
        return this.isButton( index, 'save' )
      },

      /**
       * Получение текста.
       *
       */
      getMessage( name ) {

        let messages = this.getMessages

        return messages[ name ]
      },

      /**
       * Открытие диалогового окна.
       *
       */
      show() {

        console.log( `publication >>> `, this.publication )
        console.log( `process >>> `, this.process )

        this.dialog = true
        this.init()
      },

      /**
       * Закрытие диалогового окна.
       *
       */
      hide() {
        this.dialog = false
      },

      /**
       *
       *
       */
      onFromDate( date ) {
        this.system.startDate = date
        this.$emit( 'startDate', date )
      },

      /**
       *
       *
       */
      onToDate( date ) {
        this.system.finishDate = date
        this.$emit( 'finishDate', date )
      },

      /**
       * Отмена и закрытие диалогового окна.
       *
       */
      cancel() {

        this.dialog = false
        this.resetSystemData()
        this.$emit( 'cancel' )
      },

      /**
       *
       *
       */
      getStartDate() {
        return this.startDate
      },

      /**
       *
       *
       */
      getFinishDate() {
        return this.finishDate
      },

      /**
       *
       *
       */
      getStatusName( status ) {
        return PROCESS_STATUSES[ status ]
      },

      /**
       * Получение ссылки на фото пользователя.
       *
       * @param photo
       * @returns {*}
       */
      getAccountPhotoUrl( photo ) {
        return '/disk/d/' + photo
      },

      /**
       *
       *
       */
      getProcessInfo( process, posts ) {

        if ( !process || !posts || !Array.isArray( posts ) ) {
          return false
        }

        let info = []

        info.push( this.getCustomerInfo( process, this.findCustomerPost( posts, process ) ) )
        info.push( this.getExecutorInfo( process, this.findExecutorPost( posts, process ) ) )
        info.push( this.getManagerInfo( process, this.findManagerPost( posts, process ) ) )

        info.push( this.getTagInfo( process ) )
        info.push( this.getCreatedInfo( process ) )
        info.push( this.getDeadlineInfo( process ) )

        if ( process.canceled_at ) {
          info.push( this.getCanceledInfo( process ) )
        }

        if ( process.finished_at ) {
          info.push( this.getFinishedInfo( process ) )
        }

        info.push( this.getStatusInfo( process ) )

        return info
      },

      /**
       *
       *
       */
      findCustomerPost( posts, process ) {
        return posts.find( post => post.id === process.customer_id )
      },

      /**
       *
       *
       */
      findExecutorPost( posts, process ) {
        return posts.find( post => post.id === process.contractor_id )
      },

      /**
       *
       *
       */
      findManagerPost( posts, process ) {
        return posts.find( post => post.id === process.manager_id )
      },

      /**
       *
       *
       */
      getTemplateInfo( type, value = null ) {

        let template = PROCESS_INFO_TEMPLATES.find( item => item.type === type )

        if ( !template ) {
          return null
        }

        if ( value ) {
          template.title = value
        }

        return template
      },

      /**
       *
       *
       */
      getContractorInfo( post, role ) {

        let value = post ? `${post.fullname} (${post.name})` : '-'
        let info = this.getTemplateInfo( role, value )

        if ( post && post.photo ) {
          info.photo = this.getAccountPhotoUrl( post.photo )
        }
        else {
          info.photo = null
        }

        return info
      },

      /**
       *
       *
       */
      getCustomerInfo( process, post ) {
        return this.getContractorInfo( post, 'customer' )
      },

      /**
       *
       *
       */
      getExecutorInfo( process, post ) {
        return this.getContractorInfo( post, 'executor' )
      },

      /**
       *
       *
       */
      getManagerInfo( process, post ) {
        return this.getContractorInfo( post, 'manager' )
      },

      /**
       *
       *
       */
      getTagInfo( process ) {
        return this.getTemplateInfo( 'tag', process.tag )
      },

      /**
       *
       *
       */
      getCreatedInfo( process ) {

        let created = process.created_at
          ? this.formatDatetime( process.created_at ).date.format( DATETIME_FORMAT )
          : null

        return this.getTemplateInfo( 'created', created )
      },

      /**
       *
       *
       */
      getDeadlineInfo( process ) {

        moment.locale('ru')

        let timeLimit = process.created_at && process.time_limit
          ? moment( this.formatDatetime( process.created_at ).date.valueOf() + process.time_limit * 1000 ).format( DATETIME_FORMAT )
          : null

        return this.getTemplateInfo( 'deadline', timeLimit )
      },

      /**
       *
       *
       */
      getFinishedInfo( process ) {

        let finished = process.finished_at
          ? this.formatDatetime( process.finished_at ).date.format( DATETIME_FORMAT )
          : null

        return this.getTemplateInfo( 'finished', finished )
      },

      /**
       *
       *
       */
      getCanceledInfo( process ) {

        let canceled = process.canceled_at
          ? this.formatDatetime( process.canceled_at ).date.format( DATETIME_FORMAT )
          : null

        return this.getTemplateInfo( 'canceled', canceled )
      },

      /**
       *
       *
       */
      getStatusInfo( process ) {
        return this.getTemplateInfo( 'status', this.getStatusName( process.status_name ) )
      },

      /**
       * Получение набора опций.
       *
       */
      getOptions() {

        return {
          contractorId: this.contractor,
          startDate: this.system.startDate,
          finishDate: this.system.finishDate,
          name: this.system.name,
          description: this.system.description,
          system: this.data,
          contractors: this.executors
        }
      },

      /**
       *
       *
       */
      getFile( index, file ) {

        this.filesToDisk.push( {
          index: index,
          file: file
        } );
      },

      /**
       * Получение названия компонента по указанному типу.
       *
       */
      getFormComponent( type ) {

        if ( typeof this.formComponents[ type ] === 'string' ) {
          return this.formComponents[ type ]
        }

        return null
      },

      /**
       *
       *
       */
      setStartStep() {

        if ( !this.publication ) {
          return false
        }

        this.step = 1
        this.loading = true
        this.form = []

        // Получение формы данных.
        return apiRun.startForm( this.publication.id )
          .then( data => {

            this.form = data.data
            this.initOptions( data )
            this.initSteps()
          } )
          .catch( ( error ) => {

            console.error( error )

            this.error = true
            this.$dmsErrorNoty( 'Форма данных для запуска процесса не получена. Произошла ошибка при обращении к серверу.' )
          } )
          .finally( () => {
            this.loading = false
          } )
      },

      /**
       *
       *
       */
      stepPort() {

        this.step = 1
        this.loading = true
        this.form = []

        // Получение списка портов для завершения процесса.
        return apiRun.ports( this.process.id )
          .then( data => {

            this.ports = data.data
            this.initSteps()

            // Если исходящий порт один и
            // включен режим быстрого завершения процесса:
            if ( this.quickFinish && this.ports.length === 1 ) {

              this.portId = this.ports[ 0 ].id

              apiRun.finishForm( this.process.id, this.portId )
                .then( data => {
                  this.loading = false
                  this.form = data.data
                } )
            }
            else {
              this.loading = false
            }
          } )
      },

      /**
       *
       *
       */
      setFormStep( portId ) {

        this.nextStep( this.step )

        this.loading = true

        this.portId = portId

        // Получение формы данных для завершения процесса.
        return apiRun.finishForm( this.process.id, this.portId )
          .then( data => {

            this.loading = false
            this.form = data.data
          } )
          .catch( ( error ) => {

            console.error( error )

            this.error = true
            this.$dmsErrorNoty( 'Форма данных для завершения процесса не получена. Произошла ошибка при обращении к серверу.' )
          } )
          .finally( () => {
            this.loading = false
          } )
      },

      /**
       * Получение входящих и исходящих данных процесса.
       *
       */
      getData() {

        // Получение данных процесса.
        return apiRun.data( this.process.id )
          .then( data => {

            this.inputData = data.input
            this.outputData = data.output
          } )
          .catch( ( error ) => {

            console.error( error )

            this.error = true
            this.$dmsErrorNoty( 'Данные процесса не получены. Произошла ошибка при обращении к серверу.' )
          } )
          .finally( () => {
            this.loading = false
          } )
      },

      /**
       * Подтверждение запуска процесса.
       *
       */
      confirmStart() {

        return Promise.all( this.uploadFile() )
          .then( () => {

            this.startProcess()
          } )
          .catch( ( error ) => {

            console.error( error )
            this.error = true
          } );
      },

      /**
       * Подтверждение завершения процесса.
       *
       */
      confirmFinish() {

        return Promise.all( this.uploadFile() )
          .then( () => {

            this.finishProcess()
          } )
          .catch( ( error ) => {

            console.error( error )
            this.error = true
          } );
      },

      /**
       * Запуск процесса.
       *
       */
      startProcess() {

        if ( !this.publication ) {
          return false
        }

        this.loading = true

        return apiRun.start( this.publication.id, this.form, this.getOptions() )
          .then( ( data ) => {
            this.$emit( 'start', data.process_instance )
          } )
          .catch( ( error ) => {

            console.error( error )

            this.error = true
            this.$dmsErrorNoty( 'Процесс не запущен. Произошла ошибка при обращении к серверу.' )
          } )
          .finally( () => {
            this.nextStep( this.step )
            this.loading = false
          } )
      },

      /**
       * Завершение процесса.
       *
       */
      finishProcess() {

        this.loading = true

        return apiRun.finish( this.process.id, this.portId, this.form )
          .then( () => {
            this.$emit( 'finish', this.process.id )
          } )
          .catch( ( error ) => {

            console.error( error )

            this.error = true
            this.$dmsErrorNoty( 'Процесс не завершен. Произошла ошибка при обращении к серверу.' )
          } )
          .finally( () => {
            this.nextStep( this.step )
            this.loading = false
          } )
      },

      /**
       * Редактирование процесса.
       *
       */
      editProcess() {

        return apiRun.edit( this.process.id, [], this.getOptions() )
          .then( ( response ) => {
            this.$emit( 'edit', response.process )
          } )
          .catch( ( error ) => {

            console.error( error )

            this.error = true
            this.$dmsErrorNoty( 'Процесс не изменен. Произошла ошибка при обращении к серверу.' )
          } )
          .finally( () => {
            this.nextStep( this.step )
            this.loading = false
          } )
      },

      /**
       * Загрузка файлов на сервер (сервис Диск).
       *
       */
      uploadFile() {

        this.filesToDisk.forEach( ( data ) => {

          let index = data.index
          let file = data.file
          let fileData = new FormData

          fileData.append( 'file', file );
          fileData.append( 'name', file.name )

          this.loadingDialog = true

          this.cancelTokenSource = cancelToken.source()

          this.promisesToDisk.push( apiDisk.uploadFile( fileData, this.cancelTokenSource.token )
            .then( response => {

              this.form[ index ].value = response.token
            } )
            .catch( error => {

              let message = ( error.message && error.message.length > 0 )
                ? error.message
                : this.getMessage( 'fileUploadError' )
              this.$dmsErrorNoty( message )
            } )
            .finally( _ => {

              this.loadingDialog = false
              this.cancelTokenSource = null
            } ) )
        } )

        return this.promisesToDisk;
      },

      /**
       * Поиск индекса исполнителя по идентификатору
       * в списке назначенных исполнителей.
       *
       * @param id
       * @returns {number}
       */
      findExecutorIndex( id ) {
        return this.executors.findIndex( executor => executor.id === id )
      },

      /**
       * Поиск индекса исполнителя по идентификатору должности
       * в списке назначенных исполнителей.
       *
       * @param postId
       * @returns {number}
       */
      findExecutorIndexByPostId( postId ) {
        return this.executors.findIndex( executor => executor.post_id === postId )
      },

      /**
       * Поиск исполнителя по идентификатору
       * в списке назначенных исполнителей.
       *
       * @param id
       * @returns {number}
       */
      findExecutor( id ) {
        return this.executors.find( executor => executor.id === id )
      },

      /**
       * Поиск исполнителя по идентификатору должности
       * в списке назначенных исполнителей.
       *
       * @param postId
       * @returns {number}
       */
      findExecutorByPostId( postId ) {
        return this.executors.find( executor => executor.post_id === postId )
      },

      /**
       * Получение идентификаторов всех назначенных исполнителей.
       *
       */
      getExecutorsIds() {
        return this.executors.map( executor => executor.id )
      },

      /**
       * Получение идентификаторов должностей
       * всех назначенных исполнителей.
       *
       */
      getExecutorsPostsIds() {
        return this.executors.map( executor => executor.post_id )
      },

      /**
       *
       *
       */
      onAddExecutor() {
        this.$nextTick( () => {
          this.$refs.executorPicker.show()
        } )
      },

      /**
       * Получение нового объекта исполнителя.
       *
       */
      getExecutor( id, postId, name, post, photo, rate, unit, role = 10 ) {

        let executor = {
          post_id: postId,
          role: role,
          name: name,
          post: post,
          photo: photo,
          rate: rate,
          unit: unit
        }

        if ( id ) {
          executor.id = id
        }

        return executor
      },

      /**
       * Обновление списка исполнителей.
       *
       */
      onRefreshExecutors( posts ) {

        let executors = []

        posts.forEach( ( post ) => {

          let executor = this.findExecutorByPostId( post.id )

          executors.push( this.getExecutor(
            executor ? executor.id : null,
            post.id,
            post.userName,
            post.postName,
            this.getAccountPhotoUrl( post.photo ),
            executor ? executor.rate : DEFAULT_RATE_VALUE,
            executor ? executor.unit : DEFAULT_RATE_UNIT,
            executor ? executor.role : 1
          ) )
        } )

        this.executors = executors
      },

      /**
       * Удаление исполнителя из списка.
       *
       * @param postId
       */
      onDeleteExecutor( postId ) {

        let index = this.findExecutorIndexByPostId( postId )

        if ( index !== -1 ) {
          this.executors.splice( index, 1 )
        }
      },

      /**
       * Изменение ведущего исполнителя процесса.
       *
       * @param postId
       */
      onPrimaryExecutor( postId ) {

        this.executors = this.executors.map( executor => {

          if ( executor.post_id !== postId ) {
            executor.role = 1
          }

          return executor
        } )
      },

      /**
       * Получение данных (имя, должность, фото) сотрудников.
       *
       */
      getPostsData( ids = [] ) {

        return new Promise( ( resolve, reject ) => {
          // Получение информации (имя, должность, фото) о сотрудниках.
          return this.$store.dispatch( 'app/org/entitiesInfo', { posts: ids, containers: [] } ).then(
            response => {
              resolve( response.posts_data )
            },
            error => {
              reject( error )
            }
          )
        } )
      },

      /**
       * Установка исполнителей по умолчанию.
       *
       */
      setDefaultExecutors() {

        console.log(`Формирование списка исполнителей по умолчанию`)

        this.executors = []
        let post = this.selfPost

        return this.getPostsData( [ post.id ] ).then( posts => {

          let post = posts.length
            ? posts[ 0 ]
            : null

          if ( !post ) {
            return
          }

          this.executors.push(
            this.getExecutor(
              null,
              post.id,
              post.fullname,
              post.name,
              this.getAccountPhotoUrl( post.photo ),
              DEFAULT_RATE_VALUE,
              DEFAULT_RATE_UNIT
            )
          )
        } )
      },

      /**
       * Загрузка полных данных (имя, должность, фото) назначенных исполнителей.
       *
       */
      loadProcessExecutors() {

        let postsIds = []

        // Если для процесса назначены исполнители:
        if ( Array.isArray( this.process.contractors ) && this.process.contractors.length !== 0 ) {

          // Сбор идентификаторов должностей процессов.
          postsIds = this.process.contractors.map( contractor => {
            return contractor.post_id
          } )
        }

        this.executors = []

        //
        this.getPostsData( postsIds ).then( posts => {

          posts.forEach( post => {

            // Поиск исполнителя процесса по идентификатору должности.
            let executor = this.process.contractors.find( executor => executor.post_id === post.id )

            this.executors.push(
              this.getExecutor(
                executor ? executor.id : null,
                post.id,
                post.fullname,
                post.name,
                this.getAccountPhotoUrl( post.photo ),
                executor ? executor.rate : DEFAULT_RATE_VALUE,
                executor ? executor.unit : DEFAULT_RATE_UNIT,
                executor ? executor.role : 1
              )
            )
          } )

        } )

        //
        this.getPostsData( [ this.process.customer_id, this.process.contractor_id, this.process.manager_id ] ).then( posts => {
          // Вывод информации о процессе (задаче).
          this.processInfo = this.getProcessInfo( this.process, Array.isArray( posts ) ? posts : [] )
        } )
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/apps/bpm/components/process/ProcessControlPanel.vue